var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{class:[_vm.props.edit ? 'profile__header_edit' : 'profile__header']},[_c('div',{class:[_vm.props.edit ? 'profile__header__content_edit' : 'profile__header__content']},[_c('div',{staticClass:"profile__header__content__center"},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a375716","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/profile/ProfileHeader.vue
// module id = null
// module chunks = 